import React, { useState, useRef, useEffect } from "react";
import emailjs from "@emailjs/browser";
import {
  FaPaperPlane, FaGithub, FaLinkedin, FaInstagram,
  FaEnvelope, FaPhone, FaMapMarkerAlt,
} from "react-icons/fa";
import { personalInfo, socialLinks } from "../../data/portfolioData";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(false);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);
  const formRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    setError(false);

    emailjs
      .sendForm(
        "service_fgj1cnr",   // TODO: Replace with your EmailJS Service ID
        "template_vxp4nti",  // TODO: Replace with your EmailJS Template ID
        formRef.current,
        "58AF8LDyY_FCm5lnL"    // TODO: Replace with your EmailJS Public Key
      )
      .then(() => {
        setSubmitted(true);
        setFormData({ name: "", email: "", message: "" });
        setSending(false);
        setTimeout(() => setSubmitted(false), 4000);
      })
      .catch(() => {
        setError(true);
        setSending(false);
        setTimeout(() => setError(false), 4000);
      });
  };

  return (
    <section className="contact" id="contact" ref={sectionRef}>
      <div className="contact__container">
        <h2 className="section-title">Get In Touch</h2>
        <p className="section-subtitle">
          Have a project in mind? Let's talk!
        </p>

        <div className="contact__grid">
          {/* Info */}
          <div className={`contact__info ${visible ? "animate-slide-right" : ""}`}>
            <h3>Let&#39;s Connect</h3>
            <p>
              I'm always open to discussing new projects, creative ideas, or
              opportunities to be part of your visions.
            </p>

            <div className="contact__details">
              <div className="contact__detail">
                <FaEnvelope className="contact__detail-icon" />
                <div>
                  <span>Email</span>
                  <a href={`mailto:${personalInfo.email}`}>
                    {personalInfo.email}
                  </a>
                </div>
              </div>
              <div className="contact__detail">
                <FaPhone className="contact__detail-icon" />
                <div>
                  <span>Phone</span>
                  <a href={`tel:${personalInfo.phone}`}>
                    {personalInfo.phone}
                  </a>
                </div>
              </div>
              <div className="contact__detail">
                <FaMapMarkerAlt className="contact__detail-icon" />
                <div>
                  <span>Location</span>
                  <p>{personalInfo.location}</p>
                </div>
              </div>
            </div>

            <div className="contact__socials">
              <a href={socialLinks.github} target="_blank" rel="noreferrer" aria-label="GitHub">
                <FaGithub />
              </a>
              <a href={socialLinks.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); document.getElementById('contact').scrollIntoView({ behavior: 'smooth' }); }} aria-label="Email">
                <FaEnvelope />
              </a>
              <a href={socialLinks.instagram} target="_blank" rel="noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
            </div>
          </div>

          {/* Form */}
          <form
            ref={formRef}
            className={`contact__form ${visible ? "animate-slide-left" : ""}`}
            onSubmit={handleSubmit}
          >
            {submitted && (
              <div className="contact__success">
                Message sent successfully! I'll get back to you soon.
              </div>
            )}
            {error && (
              <div className="contact__error">
                Oops! Something went wrong. Please try again.
              </div>
            )}

            <div className="form__group">
              <label htmlFor="name">Your Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="John Doe"
                required
              />
            </div>

            <div className="form__group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="john@example.com"
                required
              />
            </div>

            <div className="form__group">
              <label htmlFor="message">Your Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Tell me about your project..."
                rows="5"
                required
              />
            </div>

            <button type="submit" className="btn btn--primary btn--full" disabled={sending}>
              <FaPaperPlane /> {sending ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
